import { MarketProviderSetStatus, ProviderSetBadge } from "@app/operations/market-nightly-refresh/interfaces";
import { copyToClipboardWithToast } from "@app/operations/market-nightly-refresh/utils";
import { Badge, BadgeClassNames } from "@app/shared/Badge";
import cx from "classnames";
import { FC } from "react";

interface CopyCellProps {
  label: string;
  value: number | null;
}

export const CopyCell: FC<CopyCellProps> = ({ label, value }) => {
  if (value == null) return <span>-</span>

  return (
    <button className="market-nightly-refresh__copy-cell"
      onClick={() => copyToClipboardWithToast(value.toString(), label)}
    >
      {value}
    </button>
  )
}

const STATUS_DOT_CLASS: Record<MarketProviderSetStatus, string> = {
  Cancelled: "market-nightly-refresh__status-dot--cancelled",
  Completed: "market-nightly-refresh__status-dot--completed",
  Failed: "market-nightly-refresh__status-dot--failed",
  Pending: "market-nightly-refresh__status-dot--pending",
  Processing: "market-nightly-refresh__status-dot--processing market-nightly-refresh__status-dot--processing-anim",
};

interface StatusCellProps {
  status: MarketProviderSetStatus | null;
}

export const StatusCell: FC<StatusCellProps> = ({ status }) => {
  if (status == null) return <span>-</span>;
  return (
    <span className="market-nightly-refresh__status-cell">
      <span className={cx("market-nightly-refresh__status-dot", STATUS_DOT_CLASS[status])} />
      {status}
    </span>
  );
}

interface YesNoCellProps {
  value: boolean | null;
}

export const YesNoCell: FC<YesNoCellProps> = ({ value }) => {
  if (value == null) return <span>-</span>;
  if (value) return <span className="market-nightly-refresh__yesno-cell market-nightly-refresh__yesno-cell--yes">Y</span>
  return <span className="market-nightly-refresh__yesno-cell market-nightly-refresh__yesno-cell--no">N</span>
}

const BADGE_CONFIG: Record<ProviderSetBadge, { badgeType: BadgeClassNames; label: string }> = {
  "excluded": { badgeType: "badge--neutral", label: "Ignored" },
  "ignore-pending": { badgeType: "badge--warning", label: "Ignore pending" },
  "included": { badgeType: "badge--success", label: "Override" },
  "remove-ignore-pending": { badgeType: "badge--warning", label: "Remove ignore pending" },
  "system-ignored": { badgeType: "badge--info", label: "System-ignored" },
};

interface BadgeCellProps {
  badge: ProviderSetBadge | null;
}

export const BadgeCell: FC<BadgeCellProps> = ({ badge }) => {
  if (!badge) return null;
  return (
    <span className="market-nightly-refresh__badge-cell">
      <Badge badgeType={BADGE_CONFIG[badge].badgeType}>
        {BADGE_CONFIG[badge].label}
      </Badge>
    </span>
  );
}
